let SSQUrl = '';
if(window.location.href.indexOf('test.lvsehuilian.cn') >= 0){
    SSQUrl = 'https://wx105.bestsign.info'
} else {
    SSQUrl = 'https://wx107.bestsign.cn'
}

  
export {
    SSQUrl,
}



// WEBPACK FOOTER //
// ./src/utils/config.js